import React from "react";
import "../../styles/Banners.css";
import "../../styles/Fonts.css"
import "../../styles/Containers.css"
import "../../styles/Colors.css"
import TopNavbarBack from "../../components/TopNavbarBack";
import GoToTop from "../../components/GoToTop";

export default function TutorialWhy() {
  return (
    <div className="">
      <TopNavbarBack
          title=""
          rbuttonIcon={["icon-iconchevron-right"]}
          rbuttonHref={["/"]}
          rbackground={["rectangle"]}
          lbuttonIcon={["dNone"]}
          lbuttonHref={["null"]}
          lbackground={["dNone"]}
        />
      <div className="tutorial">

        <h2>چرا از فودپلنر استفاده کنم؟ </h2>
        <p>فودپلنر "Food Planner" مجموعه‌ای از ویژگی‌ها رو داره که با استفاده از اونها می‌تونی به سادگی و در بهینه‌ترین شکل نیازهای آشپزخانه‌ت رو برآورده کنی!
        </p>

        <br />

        <div className="b-blue20perc grey-1 paddingSide5 paddingTop1 paddingButtom5 radius1">
        <h2>با این برنامه می‌تونی :</h2>
          <li>&#x2764;&nbsp;برای وعده‌های غذایی طول هفته برنامه‌ریزی کنی! </li>
          <br/>
          <li>&#x2764;&nbsp;از لیست خریدی که به طور خودکار برات ساخته می‌شه، استفاده کنی!</li>
          <br/>
          <li>&#x2764;&nbsp;روی سلامت تغذیه خودت و خانواده‌ کنترل بهتری داشته باشی!</li>
          <br/>
          <li>&#x2764;&nbsp;هزینه‌هایی که برای نداشتن غذا می‌پردازی، مثل خوردن غذاهای ناسالم، از بین میرن و کلی جایزه و انگیزه خفن داری که تو رو به اون چیزی از خودت که بیشتر دوست داری می‌رسونن!</li>
        </div>
      </div>
      <GoToTop />
    </div>
  );
}
